export const getErrorStatus = (resp) => resp?.data?.status ?? null;

export const getToastMessage = (resp) => {
    const status = getErrorStatus(resp);
    const isUserFacing = status >= 400 && status < 500 && status !== 401 && status !== 403;
    return (isUserFacing && resp.data.title) || "Что-то пошло не так";
};
